type RefreshOption = Readonly<{
  label: string;
  value: number;
}>;

type StatisticsRefreshControlProps = Readonly<{
  ariaLabel: string;
  className: string;
  draftRefreshIntervalMs: number;
  isApplyDisabled: boolean;
  isRefreshDisabled?: boolean;
  options: readonly RefreshOption[];
  updatedAt: number;
  onApply: () => void;
  onChange: (value: number) => void;
  onRefresh: () => void;
}>;

const RefreshIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

function formatUpdatedAt(updatedAt: number) {
  return new Date(updatedAt).toLocaleTimeString('ko-KR', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  });
}

export function StatisticsRefreshControl({
  ariaLabel,
  className,
  draftRefreshIntervalMs,
  isApplyDisabled,
  isRefreshDisabled = false,
  options,
  updatedAt,
  onApply,
  onChange,
  onRefresh,
}: StatisticsRefreshControlProps) {
  return (
    <div className={className}>
      {updatedAt > 0 && <span>최근 갱신 {formatUpdatedAt(updatedAt)}</span>}
      <select
        aria-label={ariaLabel}
        value={draftRefreshIntervalMs}
        onChange={(event) => onChange(Number(event.target.value))}
      >
        {options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <button
        className="statistics-refresh-apply-button"
        type="button"
        disabled={isApplyDisabled}
        onClick={onApply}
      >
        적용
      </button>
      <button
        className="statistics-refresh-icon-button"
        type="button"
        title="지금 새로고침"
        aria-label="지금 새로고침"
        disabled={isRefreshDisabled}
        onClick={onRefresh}
      >
        <RefreshIcon />
      </button>
    </div>
  );
}
